import Vue from 'vue'
import Router from 'vue-router'
/*import Resource from 'vue-resource'*/

import Home from '../components/home'  //首页
import Index from '../components/home/index' //index
import Active from '../components/home/active'

import Detail from '../components/detail'   //详情页面

import Entryform from '../components/entryform'  //爱秀报名表
import FormNotice from  '../components/entryform/notice' //表单渲染
import FormSignUp from  '../components/entryform/signUp' //报名须知
import FormRevise from  '../components/myActivity/MyParticipate-message.vue' //修改报名表

import Video from '../components/video'//爱秀视频播放-分享

import VideoName from '../components/videoName'//爱秀视频播放

import Login from '../components/login'//登录页面
import SignIn from  '../components/login/signIn' //登录
import Quick from  '../components/login/quick' //快捷登录
import Register from  '../components/login/register' //注册
import Repassword from  '../components/login/repassword' //找回密码


import MyMessage from '../components/myMessage'//登录后
import MyActivity from '../components/myActivity'//登录后的活动
import MyParticipate from '../components/myActivity/participate'
import MyFollow from '../components/myActivity/follow'
import MyUpload from '../components/myActivity/upload'
import MyNotice from '../components/myActivity/notice'



import Discovery from '../components/discovery'//全部文件页面

import Find from '../components/find'//活动页面

import List from '../components/list' //列表
import ListVideo from '../components/list/videoList' //视频列表
import VoteList from '../components/list/voteList' //投票
import Preview from '../components/list/preview' //投票信息
import ImgList from '../components/list/imgList' //图片

import NotFound from '../components/template/notFound.vue' //活动下线


import { IsPC } from './util.js'; //是否pc端打开
let isPc = IsPC();

Vue.use(Router);
/*Vue.use(Resource);*/

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: '/h5/',
  // scrollBehavior (to, from, savedPosition) {
  //   if(savedPosition){
  //     $('html,body').stop().animate({scrollTop: savedPosition.y + 'px'}, 200);
  //     $('.content-inner-box').stop().animate({scrollTop: savedPosition.y + 'px'}, 200);
  //   }
  // },
  routes: [
    {
      path: '/',
      redirect: "/home",
      name: 'home',
      meta: {
        keepAlive: false,
        title: '央视喊你上电视',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动',
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: false,
        title: '央视喊你上电视',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动',
      },
      beforeEnter: (to, from, next) => {
        if(isPc){
          location.href = '/index.html'
        }
        next();
      },
      // redirect:'/index',
      children: [
        {path: '', redirect: '/index'},
        {
          path: "/index",
          name: "HomeIndex",
          meta: {
            keepAlive: false,
            title: '央视喊你上电视',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动',
          },
          component: Index //resolve => require(["@/components/home/index"],resolve) //首页推荐
        },
        {
          path: "/channel/:id",
          name: "HomeChannel",
          meta: {
            keepAlive: true,
            title: '央视喊你上电视',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动',
          },
          beforeEnter: (to, from, next) => {
             if(isPc){
                location.href = '/discovery.html?channel=' + to.params.id;
              }
              next();
          },
          component: Active//resolve => require(["@/components/home/active"],resolve) //首页活动
        }
      ]
    },
    {
      path: '/detail/:id',
      name: 'Detail',
      component: Detail,
      meta: {
        keepAlive: true,
        title: '',
        keywords: ''
     },
     beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/detail.html?ad=' + to.params.id;
        }
        next();
     }
    },
    {
      path: '/discovery',
      name: 'Discovery',
      component: Discovery,
      meta: {
        keepAlive: true,
        title: '优秀作品展播'
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/morevideo.html';
        }
        next();
     }
    },
    {
      path: '/find',
      name: 'Find',
      component: Find,
      meta: {
        keepAlive: false,
        title: '全部征集活动',
         keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/discovery.html';
        }
        next();
     }
    },
    {
      path: '/entryform',
      name: 'Entryform',
      component: Entryform,
      children: [
        {path: '', redirect: '/notice'},
        {
          path: '/notice/:id',
          name: 'Notice',
          meta: {
            keepAlive: false,
            title: '参与活动'
          },
          beforeEnter: (to, from, next) => {
           if(isPc){
              location.href = '/signUp.html?ad='+ to.params.id;
            }
            next();
          },
          component: FormNotice//resolve => require(['@/components/entryform/notice'],resolve),//爱秀报名表单
        },
        {
          path: '/signUp/:id/:init',
          name: 'SignUp',
          meta: {
            keepAlive: false,
            title: '参与活动'
          },
          beforeEnter: (to, from, next) => {
            console.log(to);
           if(isPc){
              location.href = '/detail.html?ad='+ to.params.id;
            }
            next();
          },
          component: FormSignUp//resolve => require(['@/components/entryform/signUp'],resolve),//爱秀报名须知
        },
        {
          path: '/revise/:id/:form_id',
          name: 'Revise',
          meta: {
            keepAlive: false,
            title: '参与活动'
          },
          beforeEnter: (to, from, next) => {
            console.log(to);
           if(isPc){
              location.href = '/revise.html?ad='+ to.params.id+ '&form=' + to.params.form_id;
            }
            next();
          },
          component: FormRevise //报名信息修改
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/index.html';
        }
        next();
      },
      meta: {
        keepAlive: false,
       title: '登录',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
       },
      children: [
        {path: '', redirect: '/signIn'},
        {
          path: '/signIn',
          name: 'login_SignIn',
          meta: {
            keepAlive: false,
            title: '登录',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
          },
          component: SignIn//resolve => require(['@/components/login/signIn'],resolve) //登录
        },
        {
          path: '/quick',
          name: 'login_Quick',
          meta: {
            keepAlive: false,
            title: '快捷登录',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
        },
          component: Quick//resolve => require(['@/components/login/quick'],resolve) //快捷登录
        },
        {
          path: '/register',
          name: 'login_Register',
          meta: {
            keepAlive: false,
            title: '注册',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

        },
          component: Register//resolve => require(['@/components/login/register'],resolve) //注册
        },
        {
          path: '/repassword',
          name: 'login_Repassword',
          meta: {
            keepAlive: false,
            title: '找回密码',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
        },
          component: Repassword //resolve => require(['@/components/login/repassword'],resolve) //找回密码
        }
      ]
    },
    ,
    {
      path: '/video/:id/:uuid',
      name: 'Video',
      component: Video,
      meta:{
        keepAlive: false,
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/video.html?d='+ to.params.uuid +'&&ad='+ to.params.id;
        }
        next();
      }
    },
    {
      path: '/videoName/:id/:uuid/:type',
      name: 'VideoName',
      component: VideoName,
      meta:{
        keepAlive: false
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/video.html?d='+ to.params.uuid +'&&ad=' + to.params.id;
        }
        next();
      }
    },
    {
      path: '/mymessage',
      name: 'MyMessage',
      component: MyMessage,
      meta: {
        keepAlive: false, // 需要被缓存
        title: '个人中心',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/partake.html';
        }
        next();
      }
    },
    {
      path: '/myActivity',
      name: 'myActivity',
      component: MyActivity,
      meta: {
        keepAlive: false,
        title: '参与活动',
        keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

      },
      beforeEnter: (to, from, next) => {
        if(isPc){
          location.href = '/partake.html';
        }
        next();
      },
      children: [
        {path: '/myActivity', redirect: '/myparticipate/:id'},
        {
          path: '/myparticipate/:id',
          name: 'myActivity_MyParticipate',
          meta: {
            keepAlive: false,
            title: '我参与活动',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

          },
          component: MyParticipate//resolve => require(['@/components/myActivity/participate'],resolve) //参与
        },
        {
          path: '/myfollow',
          name: 'myActivity_MyFollow',
          meta: {
            keepAlive: false,
            title: '我关注活动',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

        },
          component: MyFollow//resolve => require(['@/components/myActivity/follow'],resolve) //关注
        },
        {
          path: '/myupload',
          name: 'myActivity_MyUpload',
          meta: {
            keepAlive: false,
            title: '管理我的作品',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'

        },
          component: MyUpload//resolve => require(['@/components/myActivity/upload'],resolve) //上传
        },
        {
          path: '/mynotice',
          name: 'myActivity_MyNotice',
          meta: {
            keepAlive: false,
            title: '官方提醒',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
        },
          component: MyNotice//resolve => require(['@/components/myActivity/notice'],resolve) //我的
        }
      ]
    },
    {
      path: '/list',
        name: 'List',
        component: List,
        children: [
        {
          path: '/videoList/:id/:init',
          name: 'list_video',
          meta: {
            keepAlive: true,
            title: '视频作品',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
          },
          beforeEnter: (to, from, next) => {
           if(isPc){
              location.href = '/videolists.html?ad='+to.params.id;
            }
            next();
          },
          component:  ListVideo //resolve => require(['@/components/list/videoList'],resolve) //视频列表
        },
        {
          path: '/vote/:id/:active',
          name: 'list_vote',
          meta: {
            keepAlive: true,
             title: '投票'
          },
          beforeEnter: (to, from, next) => {
           if(isPc){
              location.href = '/votelists.html?ad='+to.params.id;
            }
            next();
          },
          component: VoteList//resolve => require(['@/components/list/voteList'],resolve) //投票
        },
        {
          path: '/preview/:id/:uuid/:ind/:activityId',
          name: 'list_preview',
          meta: {
            keepAlive: false,
            title: '投票-信息'
          },
          beforeEnter: (to, from, next) => {
           if(isPc){
              location.href = '/video.html?d='+ to.params.uuid +'&&ad='+ to.params.id;
            }
            next();
          },
          component:  Preview//resolve => require(['@/components/list/preview'],resolve) //投票
        },
        {
          path: '/image/:id/:init',
          name: 'list_image',
          meta: {
            keepAlive: false,
            title: '图片作品',
            keywords: '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动'
          },
          beforeEnter: (to, from, next) => {
           if(isPc){
              location.href = '/picture.html?ad='+ to.params.id +'&k='+ to.params.init;
            }
            next();
          },
          component: ImgList//resolve => require(['@/components/list/imgList'],resolve) //图片
        }
      ]

    },
    {
      path: '/notFound',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: '活动已下线'
      },
      beforeEnter: (to, from, next) => {
       if(isPc){
          location.href = '/index.html';
        }
        next();
     }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js